exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".D8PrIBfVHLaC1G{display:inline-flex;border-radius:3px;font-size:12px;padding:4px;text-decoration:none;line-height:12px}._39vNpql8O9h5co{width:12px;height:12px;margin-right:4px;line-height:12px;font-size:14px}._1xgAps5V3J3WWx{background-color:#eddbf4}._1xgAps5V3J3WWx ._39vNpql8O9h5co{color:#89609e}._1xgAps5V3J3WWx ._17EaYJuwhiq6Dy{color:#42526e}._1xgAps5V3J3WWx:hover{background-color:#dfc0eb}.fo3ROqdZZNdBSw{background-color:#89609e}.fo3ROqdZZNdBSw ._17EaYJuwhiq6Dy,.fo3ROqdZZNdBSw ._39vNpql8O9h5co{color:#fff}.fo3ROqdZZNdBSw:hover{background-color:#583f68}", ""]);

// exports
exports.locals = {
	"upgradePromptPill": "D8PrIBfVHLaC1G",
	"upgradePromptPillIcon": "_39vNpql8O9h5co",
	"upgradeLightTheme": "_1xgAps5V3J3WWx",
	"upgradePromptPillCTA": "_17EaYJuwhiq6Dy",
	"upgradeDarkTheme": "fo3ROqdZZNdBSw"
};